import React from "react";
import styles from "./phonenumber.module.css";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css"; // Optional for default styling
import { isValidPhoneNumber } from "libphonenumber-js"; // Import the validation function

const PhoneNumber = ({ id, label, itemKey, required = false, ...inputArgs }) => {
 

  return (
    <div
      className={`${styles.formGroup} ${inputArgs?.formGroupClassOverride}`}
      style={inputArgs.formGroupStyleOverride}
      key={itemKey}
    >
      {label && (
        <label style={inputArgs.labelStyleOverride} htmlFor={id}>
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      <PhoneInput
        id={id} // Use the passed id for unique identification
        country="GB" // Default country code
        defaultCountry="GB" // Set the default country code
        international // Allows users to enter international phone numbers
        countrySelectProps={{
          countries: ["GB"], // Only show Great Britain in the dropdown
        }}
        {...inputArgs}
        // onChange={handleChange} // Use the defined handler
        limitMaxLength={13}
        
        onKeyDown={(e) => {
          // Prevent editing the country code
          if (e?.key === 'Backspace' && e?.target.selectionStart <= 3) {
            e?.preventDefault();
          }
          if (e?.key === 'Delete' && e?.target.selectionStart <= 3) {
            e?.preventDefault();
          }
        }}
      />
    </div>
  );
};

export default React.memo(PhoneNumber);
